import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

class AdminUserRateRoute extends Route {
  @service store;
  @service('commands/user-commands') userCommandService;

  model() {
    const allServices = this.store.findAll('service');
    const nextQueueUser = this.userCommandService.getAdminRateQueueUser();

    return Promise.all([allServices, nextQueueUser]).then(([allServices, user]) => ({
      allServices,
      user,
    }));
  }

  /** @inheritDoc */
  setupController(controller, model) {
    super.setupController(...arguments);
    controller.loadClassificationsTask.perform();

    const adminUserRateController = this.controllerFor('admin.user.rate');
    adminUserRateController.setProperties({
      model,
      projects: []
    });

    if (model.user) {
      adminUserRateController.loadProjectsWaiter.perform();
    }
  }

  /** @inheritDoc */
  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      const adminUserRateController = this.controllerFor('admin.user.rate');
      if (adminUserRateController) {
        adminUserRateController.loadProjectsWaiter.cancelAll({ resetState: true });
      }

      controller.loadNextUser.cancelAll({ resetState: true });
      controller.loadClassificationsTask.cancelAll({ resetState: true });
    }
  }
}

export default AdminUserRateRoute;
